import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { FormEvent } from 'react';
import { Nav } from 'react-bootstrap';
import { NavItemWrapper } from '../styles';
import { NavWrapper } from './styles';

interface IProps {
    activeKey: string,
    centerId: number,
    itemId?: number,
    isAdmin: boolean,
    onTabSelect: (key: string) => void
}

const ActionCenterNav = (props: IProps) => {
    const { app } = useAppHookContext();

    const handleSelect = (e: FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const hrefPrefix = `/center/${props.centerId}/action-center`;

    const show = app.site.organType == OrganType.Kidney;

    const tabs = [
        { eventKey: 'TO-DO', label: <>TO-DO</>, href: hrefPrefix + '/to-do', show: true, },
        { eventKey: 'PENDING-SWAPS', label: <>Swaps</>, href: hrefPrefix + '/pending-swaps', show },
        { eventKey: 'MOVE-TRACKER', label: <>Move<br />Tracker</>, href: hrefPrefix + '/move-tracker', show },
        { eventKey: 'CENTER-PERFORMANCE', label: <>Center<br />Performance</>, href: hrefPrefix + '/center-performance', show },
        { eventKey: 'XM-TRACKING', label: <>XM<br />Tracking</>, href: hrefPrefix + '/xm-tracking/by-your-center', show },
        { eventKey: 'SEROLOGY-TRACKING', label: <>Serology<br />Tracking</>, href: hrefPrefix + '/serology-tracking/by-your-center', show },
        { eventKey: 'PHLEBOT-TRACKING', label: <>Phlebotomy<br />Tracking</>, href: hrefPrefix + '/phlebot-tracking', show },
        { eventKey: 'EXPERT-SYSTEM', label: <>Expert<br />System</>, href: hrefPrefix + '/expert-system', show },
        { eventKey: 'HOME-BLOOD-DRAW', label: <>Home<br />Blood Draw</>, href: hrefPrefix + '/home-blood-draw', show: true },
        { eventKey: 'ORDER-TRACKING', label: <>Order <br /> Tracking</>, href: hrefPrefix + '/order-tracking', show: true },
        { eventKey: 'RCCAP-RESPOND', label: <>RCCAP Response</>, href: hrefPrefix + '/rccap-respond/' + props.itemId, show: props.activeKey == 'RCCAP-RESPOND' },
        { eventKey: 'RCCAP-VIEW', label: <>RCCAP Info</>, href: hrefPrefix + '/rccap-view/' + props.itemId, show: props.activeKey == 'RCCAP-VIEW' },
        { eventKey: 'SUPPORT', label: <>Support</>, href: hrefPrefix + '/support', show: true },
        { eventKey: 'CREATE-TICKET', label: <>Create Support Ticket</>, href: hrefPrefix + '/create-ticket', show: props.activeKey.toUpperCase() == 'CREATE-TICKET' },
        { eventKey: 'SWAP-QUALITY-ISSUES', label: <>Swap Quality<br />System</>, href: hrefPrefix + '/swap-quality-issues/list/pending-response', show }
    ]

    return (
        <NavWrapper
            bsStyle='tabs'
            activeKey={props.activeKey}
            verticalAlign='center'
            minTabWidth='100'
            height={app.site.organType == OrganType.Kidney ? null : '45px'}
            backgroundColor={app.site.organType == OrganType.Kidney ? null : '#0E395C'}
            onSelect={handleSelect}
        >
            {tabs.filter(x => x.show).map((tab, index) =>
                <NavItemWrapper key={'tab-' + index} eventKey={tab.eventKey} href={tab.href}>
                    {tab.label}
                </NavItemWrapper>
            )}
        </NavWrapper>
    );
}

export default ActionCenterNav;